import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Map old Wix product-page slugs to React product slugs
var wixToReactSlugMap = {
  'forscore-page-turner': 'noteturner',
  'muteclip-x1': 'muteclip',
  'jimendez-practice-mute': 'practice-mute',
  'mutecap': 'mutecap',
  'fingerflow': 'fingerflow',
  'the-brass-plank': 'brass-plank',
  'piccolo-mute': 'piccolo-mute',
  'mutemute': 'mutemute',
  'belloflex-trumpet-cup-mute': 'belloflex-mute',
  'nimbus-bucket-mute': 'nimbus-bucket-mute',
  'cork-for-harmon-mute': 'cork-harmon-mute',
  'soniclift': 'soniclift',
  'brassgutter': 'brassgutter',
  'pentagram-pen': 'staff-writter',
  'ganschtrigger': 'ganschtrigger',
  'trumpet-visualizer-1': 'trumpet-visualizer',
  'brassblast': 'brassblast',
  'trumpet-o-rings-for-slides': 'trumpet-o-rings',
  'water-key-tip-cover-fits-yamaha-bach-most-trpts': 'water-key-tip-cover',
  'neocap': 'neocap-pouch',
  'pencil-holder': 'pencil-holder',
  'glow-in-the-dark-cap-for-k-m-stand': 'glow-cap-km-stand',
  'trombone-holder': 'trombuddy',
  'mouthpiece-holder': 'mouthpiece-holder',
  'slide-rubber-bands': 'slide-rubber-bands',
  'buzzing-extension': 'buzztone',
  'yamaha-personal-studio-for-trumpet': 'yamaha-personal-studio',
  'gl-trumpet-case': 'gl-trumpet-case',
  'yamaha-double-case': 'yamaha-double-case',
  'p-mauriat-pmt-75-ti-x-cu': 'p-mauriat-pmt75',
  'bach-stradivarius-229-c-trumpet-with-original-sterling-silver': 'bach-strad-229c',
  'the-real-christmas-book-in-c': 'real-christmas-book-c',
  'real-book-vol-1-in-c-indexed-forscore': 'real-book-vol-1-c',
  'real-book-vol-2-in-c-indexed-forscore': 'real-book-vol-2-c',
  'copy-of-real-book-vol-3-in-c-indexed-forscore': 'real-book-vol-3-c',
  'the-new-real-book-vol-1-in-c-indexed-forscore': 'new-real-book-vol-1-c',
  'the-new-real-book-vol-2-in-c-indexed-forscore': 'new-real-book-vol-2-c',
  'the-new-real-book-vol-3-in-c-indexed-forscore': 'new-real-book-vol-3-c',
  'real-book-vol-1-in-bb-indexed': 'real-book-vol-1-bb',
  'real-book-vol-2-in-bb-indexed': 'real-book-vol-2-bb',
  'real-book-vol-3-in-bb-indexed-forscore': 'real-book-vol-3-bb',
  'the-new-real-book-vol-1-in-bb': 'new-real-book-vol-1-bb',
  'the-new-real-book-vol-2-in-bb': 'new-real-book-vol-2-bb',
  'the-new-real-book-vol-3-in-bb-index-forscore': 'new-real-book-vol-3-bb',
  'real-book-vol-1-in-eb-indexed-forscore': 'real-book-vol-1-eb',
  'copy-of-real-book-vol-2-in-eb-indexed-forscore': 'real-book-vol-2-eb',
  'the-new-real-book-vol-1-in-eb-indexed-forscore': 'new-real-book-vol-1-eb',
  'the-new-real-book-vol-2-in-eb-indexed-forscore': 'new-real-book-vol-2-eb',
  'copy-of-the-new-real-book-vol-3-in-eb-indexed-forscore': 'new-real-book-vol-3-eb',
  'real-book-vol-1-in-bass-clef-indexed-forscore': 'real-book-vol-1-bass',
  'art-in-trumpet': 'art-in-trumpet-album',
  'tuning-chart': 'tuning-chart',
  'malague%C3%B1a-solo-acapella-version': 'malaguena-solo',
  'malaguena-solo-acapella-version': 'malaguena-solo',
  'glier%C3%A9-french-horn-concerto-as-played-by-sergei-nakariakov': 'gliere-horn-concerto',
  'gliere-french-horn-concerto-as-played-by-sergei-nakariakov': 'gliere-horn-concerto',
  'espada-de-la-noche': 'espada-de-la-noche',
  'arabesque-no-1-1': 'arabesque-no-1',
  'the-green-hornet-acapella': 'green-hornet-acapella',
  'danse-macabre-as-recorded-on-art-in-trumpet': 'danse-macabre',
  'le-coucou': 'le-coucou',
  'i-can-t-get-started-as-played-by-bunny-barrigan': 'i-cant-get-started',
  'blue-rondo-a-la-turk-as-played-by-tine-helseth': 'blue-rondo-a-la-turk',
  'oblivion-as-played-by-tine-helseth': 'oblivion',
  'libertango-as-played-by-tine-helseth': 'libertango',
  'caprice-24': 'caprice-24',
  'les-chemins-de-l-amoure': 'les-chemins-de-lamour',
  'pavane-pour-une-infante-defunte': 'pavane-pour-une-infante-defunte',
  'the-green-hornet-full-big-band': 'green-hornet-big-band',
  'hora-staccato': 'hora-staccato',
  'danse-espagnol': 'danse-espagnol',
  'meditation': 'meditation',
  'chanson-arabe': 'chanson-arabe',
  'campanella-by-paganini': 'campanella',
  'le-plus-que-lente': 'le-plus-que-lente',
  'romanian-folk-dances': 'romanian-folk-dances',
  'mendelssohn-violin-concerto': 'mendelssohn-violin-concerto',
};

function WixProductRedirect() {
  var params = useParams();
  var navigate = useNavigate();
  var wixSlug = params['*'] || '';

  useEffect(function() {
    var decoded = decodeURIComponent(wixSlug);
    var reactSlug = wixToReactSlugMap[decoded] || wixToReactSlugMap[wixSlug] || wixSlug;
    navigate('/product/' + reactSlug, { replace: true });
  }, [wixSlug, navigate]);

  return null;
}

export default WixProductRedirect;
